export default __webpack_public_path__ + "static/media/1075-00.55f14382.jpg";